import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';

const noop = () => {};

const DisconnectAccountModal = ({
  account,
  onClose = noop,
  onConfirm = noop,
  isDisconnecting = false,
}) => {
  const overlayRef = useRef(null);
  const institution = account?.institution_name || account?.account_name || 'this account';

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !isDisconnecting) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, isDisconnecting]);

  const onOverlayClick = (e) => {
    if (e.target === overlayRef.current && !isDisconnecting) onClose();
  };

  if (!account) return null;

  return (
    <AnimatePresence>
      <motion.div
        ref={overlayRef}
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onOverlayClick}
      >
        <motion.div
          className="modal-panel max-w-md w-full mx-4"
          initial={{ opacity: 0, y: 12, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 8, scale: 0.98 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-4 mb-4">
            <h2 className="font-display text-h3 text-primary">
              Disconnect {institution}?
            </h2>
            <button
              type="button"
              onClick={onClose}
              disabled={isDisconnecting}
              className="btn-ghost p-1 disabled:opacity-50"
              aria-label="Close"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>

          <p className="text-body text-secondary mb-6">
            This will remove live data from your dashboard. Aura will fall back to your
            Cashflow entries. Your Visions will remain but progress tracking may be affected.
          </p>

          <div className="flex flex-col-reverse sm:flex-row gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isDisconnecting}
              className="btn-primary flex-1 disabled:opacity-50"
            >
              Keep Connected
            </button>
            <button
              type="button"
              onClick={() => onConfirm(account)}
              disabled={isDisconnecting}
              className="flex-1 px-4 py-2.5 rounded-md bg-danger text-white text-label font-medium hover:opacity-90 disabled:opacity-50"
            >
              {isDisconnecting ? 'Disconnecting…' : 'Disconnect'}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DisconnectAccountModal;
